import * as yup from "yup";
import { estimatedTonsSchema } from "forms/field-detail/fieldDetailFormSchema";
import { multiplierSchema } from "forms/crop-year-detail/multiplierSchema";

export const regionDetailSchema = yup.object({
  regionId: yup.string().required(),
  multiplier: multiplierSchema,
  estimatedTonsPerAcre: estimatedTonsSchema,
});
